import { TOKEN_SUCCESSFUL, TOKEN_FAILURE, TOKEN_CLEAR } from '../actions/actionTypes';
var tokenReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    if (action.type === TOKEN_SUCCESSFUL) {
        var values = action.token;
        return {
            fertigstellungsmeldung_id: values.fertigstellungsmeldung_id,
            token: values.token,
            expire: values.expire
        };
    }
    else if (action.type === TOKEN_FAILURE) {
        var error = (action.exception && action.exception.message) ? action.exception.message : 'unbekannter Fehler';
        return {
            error: error
        };
    }
    else if (action.type === TOKEN_CLEAR) {
        return null;
    }
    return state;
};
export default tokenReducer;
